<template>
  <div :class="(['golf-outer', showLoader ? 'loading' : 'loaded', currentLevel.name == 'Prime'? 'prime-level' : ''])" class="for-max-width-measure" >
    <div ref="question" v-if="!showScore && !showLoader" class="vordur-outer" :class="(!showClubJoin && !showGolf && !showFacebook && !showQuizBoard && showQuizComp ? 'question' : 'height-100')">
      <club-join v-if="showClubJoin && !showGolf" @proceedToQuiz="showRulePage" @clubData="showRulePage"></club-join>

      <golf-protection v-else-if="showGolf && !showInfoPage && !showClubJoin && (levelStatus !== 'failure')" :currentLevel="currentLevel" @proceedToQuiz="showRulePage"></golf-protection>

      <facebook-friends v-else-if="showFacebook && !showGolf && !showClubJoin" @proceedToQuiz="[proceedToQuiz,showFacebook = false,showGolf=false]" :currentLevel="currentLevel" :showFacebook="showFacebook"
      ></facebook-friends>

      <quiz-board v-else-if="showQuizBoard && !showClubJoin && !showGolf && !showFacebook" @proceedToQuiz="showQuizBoard=false" />

      <div v-else-if="showInfoPage && !showClubJoin" class="info-component">
        <info-component v-if="!showLoader" @updateProfile="$emit('updateProfile')"
          :currentLevel="currentLevel" @showLoader="showLoader=true"
          :userTotalPoints="userTotalPoints" :levelStatus="levelStatus"
          :showSucccessGreeting="showAnimatedGreeting"
          :userGameInfo="userGameInfo"
          :greetingInfo="greetingInfo"
          @greetingPar4="showClubJoin=false, showFacebook=false"
          @fbFriends ="showFacebook=true, showInfoPage=false, showClubJoin=false"
          @hideGreeting="showAnimatedGreeting=false"
          @proceedToQuiz="proceedToQuiz"></info-component>
      </div>
      <div v-else class="quiz-component-wrap" :class="((questionList && questionList.questions && !showClubJoin && !showGolf && !showFacebook) ? 'full-height' : '')">
        <quiz-component
          v-if="questionList && questionList.questions && !showClubJoin && !showGolf && !showFacebook && showQuizComp" :questionData="questionList"
          :question="questionList.questions[questionIndex]" :questionIndex="questionIndex"
          :currentLevel="currentLevel"
          :userGameInfo="userGameInfo"
          :showLoader="showLoader"
          :showQuestions="showPrime"
          :totalScore="userTotalPoints"
          @showInfo ="showInfoPage=true"
          @reTry="levelStatus='failure';proceedToQuiz('tryAgain');"
          @answerValidate="answerValidate"
          @validAnswer ="validAnswer"
          @levelValidate ="levelValidate"
          @showPrimeQuestions="showPrimeQuestions"
          @skipThisCurrentQuestion="skipThisCurrentQuestion"
        >
        </quiz-component>
      </div>
    </div>
    <div class="score-page" v-else-if="showScore && !showLoader">
      <div
        class="inner"
        :class="[valid ? '' : 'invalid']"
      >
        <div class="score-info">
          <img :src="valid ? gameContent.right_answer_loader_image : gameContent.wrong_answer_loader_image" alt="" height="216" width="188" />
          <h5>{{ (answerMsgInfo && answerMsgInfo.title && answerMsgInfo.title) ? answerMsgInfo.title : 'Frábært flug á kúlunni!' }}</h5>
          <div class="total">
            <span class="symbol" v-if="valid">+</span>
            {{ questionScore }}
          </div>
          <!-- <p class="timer" v-if="questionIndex !== (currentLevel.questions_per_level - 1)">Next question in ...{{ timerVal }}</p> -->
        </div>
      </div>
    </div>
    <div class="loader-page" v-else>
      <img :src="gameContent.scoreboard_loader_image" alt="loader" />
      <p>{{ gameContent.scoreboard_loader_text }}</p>
    </div>
  </div>
</template>
<script>
/* global gtag */
/* eslint no-undef: "error" */
import API from '@/shared/api'
import { LevelInfo, AnswerInfo, GreetingInfo } from '@/shared/dataModels'
export default {
  name: 'QuizPage',
  data () {
    return {
      dataReady: false,
      showLoader: false,
      quizCompleted: false,
      questionList: null,
      userInfo: null,
      userGameInfo: {},
      showInfoPage: false,
      currentLevel: new LevelInfo(),
      levelStatus: null,
      questionIndex: 0,
      userTotalPoints: 0,
      levelResult: null,
      showClubJoin: false,
      startAnswer: false,
      showQuizBoard: true,
      showAnimatedGreeting: false,
      valid: null,
      showGolf: false,
      showFacebook: false,
      showPrime: false,
      primeLevelBufferQuestions: [],
      showQuizComp: false,
      showScore: false,
      questionScore: 0,
      greetingInfo: new GreetingInfo(),
      answerMsgData: null,
      answerMsgInfo: {
        title: null
      },
      gameContent: {},
      gameRule: {},
      timerVal: 4,
      intervalId: null,
    }
  },
  created () {
    var apiUrl = '/level/questions/'
    this.showQuizComp = true
    if (this.$data.globalData.user) {
      this.startAnswer = true
      this.userInfo = this.$data.globalData.user
      if (this.userInfo.completed_quiz === true) {
        this.quizCompleted = true
      }
      if (this.$data.globalData.user.current_level) {
        this.currentLevel.key = this.$data.globalData.user.current_level.key
        this.currentLevel.name = this.$data.globalData.user.current_level.name
        this.currentLevel.level = this.$data.globalData.user.current_level.level

        if (this.$data.globalData.user.user_game_info) {
          this.userGameInfo = this.$data.globalData.user.user_game_info
        }
        apiUrl += '?level=' + this.$data.globalData.user.current_level.key
        this.$data.globalData.user.user_total_points = this.userTotalPoints

        // Getting the quiz info from the contentful
        if (this.$data.globalData.gameRule) {
          this.gameRule = this.$data.globalData.gameRule
          apiUrl += '&limit=' + this.gameRule.total_questions
          this.currentLevel['points_per_answer'] = this.gameRule.points_per_answer
          this.currentLevel['questions_per_level'] = this.gameRule.total_questions
          this.currentLevel['seconds_per_question'] = this.gameRule.seconds_per_question
        }
      }
      if (this.$data.globalData.gameContent) {
        this.gameContent = this.$data.globalData.gameContent
      }
      if (this.$route.query) {
        if (this.$route.query.showclub) {
          if (this.$route.query.showclub === 'true' && !this.$data.globalData.user.user_club) {
            this.showClubJoin = true
          } else {
            this.$router.replace({ path: '/spurningar/' })
          }
        }
      }
      this.getQuestionsData(apiUrl)
    } else {
      this.$router.replace({ path: '/innskraning/' }).then(() => {
        this.showLoader = true
        window.location.reload()
      })
    }
    API.meInstance.get('/answer-messages/').then((res) => {
      this.answerMsgData = res.data.data
    });
  },
  methods: {
    showRulePage () {
      this.showGolf = false;
      this.showClubJoin = false;
      this.showInfoPage = false;
      this.showQuizBoard = true;
    },
    getQuestionsData (apiUrl, showQuiz = false) {
      const levelQueryParm = {
        0: 'par3',
        1: 'par4',
        2: 'par5',
        3: 'regluvordur'
      }
      API.meInstance.get(apiUrl).then((res) => {
        if (res.data.data) {
          this.questionIndex = 0
          this.questionList = res.data.data
          // this.$router.push({ query: { lvl: levelQueryParm[0] }});
          if (res.data.data.level.name === 'Prime') {
            this.primeLevelBufferQuestions  = {'questions': []};
            const totalExtraQuestions = this.questionList.questions.length - res.data.data.level.minimum_valid_answers; //13 - 10
            this.primeLevelBufferQuestions.questions = this.questionList.questions.slice(this.questionList.questions.length - totalExtraQuestions);
            this.questionList.questions.length = res.data.data.level.minimum_valid_answers;
            // console.log(this.primeLevelBufferQuestions, this.questionList)
          }
          if (this.questionList && this.questionList.level) {
            this.currentLevel['key'] = this.questionList.level['key']
            this.currentLevel['name'] = this.questionList.level['name']
            this.currentLevel['level'] = this.questionList.level['level']
            this.currentLevel['minimum_valid_answers'] = this.questionList.level['minimum_valid_answers']
            this.currentLevel['correctAnswers'] = 0
            this.currentLevel['invalidAnswers'] = 0
            this.currentLevel['level_completed'] = false
            const freshSlot = {}
            this.currentLevel.answerSheet['questions'] = []
            let currentLevelQuestions = this.questionList.level.questions_per_level;
            if (res.data.data.level.name === 'Prime') {
              currentLevelQuestions = this.currentLevel['minimum_valid_answers'];
            }
            this.currentLevel.questions_per_level = currentLevelQuestions;
            for (let i = 0; i < currentLevelQuestions; i++) {
              const newData = new AnswerInfo(this.questionList.questions[i].key)
              this.currentLevel.answerSheet['questions'].push(newData)
              freshSlot[i.toString()] = 'not_answered'
            }
            this.currentLevel.answerSheet['user_level'] = this.currentLevel.key
            this.$set(this.userGameInfo, this.currentLevel.name, freshSlot)
          }
          this.dataReady = true
          this.showLoader = false
          if (showQuiz === true) {
            this.showInfoPage = false
          }
        }
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    showPrimeQuestions () {
      this.showPrime = true
    },
    levelValidate () {
      this.showLoader = true
      this.showQuizComp = false
      API.meInstance.post('/level/validate/', this.currentLevel['answerSheet']).then((res) => {
        this.showScore = false
        this.questionScore = 0
        if (res.data && res.data.status) {
          this.levelResult = res.data.data
          this.greetingInfo = this.$data.globalData.gameResult[this.levelResult && this.levelResult.success ? 'success' : 'failure']
          var currentPage = '/spurningar/?'
          if (this.currentLevel.name === 'Bronze') {
            currentPage += 'par3'
          } else if (this.currentLevel.name === 'Silver') {
            currentPage += 'par4'
          } else if (this.currentLevel.name === 'Gold') {
            currentPage += 'par5'
          } else if (this.currentLevel.name === 'Premium' && this.levelResult.success !== true) {
            currentPage += 'regluvordur'
          } else if (this.currentLevel.name === 'Premium' && this.levelResult.success === true) {
            currentPage += 'klarad'
          }
          gtag('config', this.$data.globalData.google_track_id, {
            'page_title' : this.currentLevel.name,
            'page_path': currentPage
          })

          if (this.levelResult.level_points) {
            this.userTotalPoints = this.levelResult.level_points
          }
          this.showAnimatedGreeting = true
          if (this.levelResult.success && this.levelResult.level_points && this.levelResult.level_points >= this.gameRule.min_best_score) {
            this.quizCompleted = true
            this.$set(this.currentLevel, 'level_completed', true)
            this.levelStatus = 'success'
            this.showInfoPage = true
            if (this.levelResult.level_points) {
              this.$data.globalData.user.user_total_points = this.levelResult.level_points
            }
            this.showLoader = false
            // window.location.href = '/verdlaun/'  
            // if (this.$data.globalData.user && this.$data.globalData.user.medal_subscribed) {
            //   this.$router.push({ name: 'RegluvardarShare' })
            // } else {
            //   this.$router.push({ name: 'MedalPage' })
            // }
          } else {
            this.levelStatus = 'failure'
            if (this.levelResult.level_points) {
              this.$data.globalData.user.user_total_points = this.levelResult.level_points
            }
            setTimeout(() => {
              this.showLoader = false
              this.showInfoPage = true
            }, 3000)
          }
        }
      })
    },
    proceedToQuiz (e) {
      this.showQuizComp = true
      this.showInfoPage = false
      if (this.levelResult || this.levelStatus === 'failure') {
        let apiUrl = '/level/questions/?level='
        if (this.levelResult && this.levelResult.success && this.levelStatus !== 'failure') {
          // this.showInfoPage = true
          // this.showGolf= true
          if(this.currentLevel.level && this.currentLevel.level === 3) {
            if (e == 'tryAgain') {
              // this.showFacebook= true
              this.showPrime = true
            }
          }
          if (this.levelResult.next_level) {
            apiUrl += this.levelResult.next_level.key
            this.getQuestionsData(apiUrl, true)
            if (this.currentLevel.level === 2) {
              this.showFacebook= true
            }
          } else {
            this.showLoader = false
          }
        } else {
          apiUrl += this.currentLevel.key
          this.getQuestionsData(apiUrl, true)
        }
        this.userTotalPoints = 0
      } else {
        this.showClubJoin = false
        this.showInfoPage = false
        this.showLoader = false
        this.showGolf = false
        this.showFacebook = false
        this.showQuizBoard = false
      }
    },
    answerValidate (resData) {
      this.showLoader = true
      if (resData) {
        if (resData.isValid) {
          this.startAnswer = true
          this.currentLevel['correctAnswers'] += 1
          this.valid = true
          this.userGameInfo[this.currentLevel.name][this.questionIndex.toString()] = true
          const reduction_points =  Math.round(this.currentLevel.points_per_answer / this.currentLevel.seconds_per_question)
          const bonus_points =  Math.round(this.currentLevel.points_per_answer - (resData['consumedTime'] * reduction_points))
          this.questionScore = this.currentLevel.points_per_answer + bonus_points
          let answerMsgIdx = 0;
          if (this.answerMsgData.success && this.answerMsgData.success.length > 0) {
            answerMsgIdx = Math.round(Math.random() * this.answerMsgData.success.length - 1)
          }
          this.answerMsgInfo = this.answerMsgData.success[answerMsgIdx]
        } else {
          this.currentLevel['invalidAnswers'] += 1
          this.valid = false
          this.userGameInfo[this.currentLevel.name][this.questionIndex.toString()] = false
          let answerMsgIdx = 0;
          if (this.answerMsgData.success && this.answerMsgData.success.length > 0) {
            answerMsgIdx = Math.round(Math.random() * this.answerMsgData.failure.length - 1)
          }
          this.answerMsgInfo = this.answerMsgData.failure[answerMsgIdx]
        }
        this.userTotalPoints += this.questionScore
        this.greetingMsg = resData.greeting
        this.currentLevel.answerSheet['questions'][this.questionIndex]['answer'] = resData.givenAnswer
        if (this.questionIndex === (this.currentLevel.questions_per_level - 1)) {
          this.showScore = true
          this.showLoader = false
          setTimeout(() => {
            this.levelValidate()
          }, 3000)
        } else {
          this.showLoader = false
          this.showScore = true
          setTimeout(() => {
            this.timer()
          }, 200)
        }
      }
    },
    validAnswer(e) {
      this.valid = e
    },
    skipThisCurrentQuestion() {
      const newQuestionData = new AnswerInfo(this.primeLevelBufferQuestions.questions[0].key);
      this.currentLevel['answerSheet'].questions.splice(this.questionIndex, 1, newQuestionData);
      // this.questionList.questions[this.questionIndex] = this.primeLevelBufferQuestions.questions[0];
      Object.assign(this.questionList.questions[this.questionIndex], this.primeLevelBufferQuestions.questions[0]);
      this.primeLevelBufferQuestions.questions.splice(0, 1);
    },
    procced() {
      this.questionIndex += 1
      this.showScore = false
      this.questionScore = 0
      this.timerVal = 4
    },
    timer() {
      this.intervalId = setInterval(() => {
        if (this.timerVal <= 2) {
          clearInterval(this.intervalId)
          this.procced()
          return
        }
        this.timerVal -= 1
      }, 1000)
    }
  },
  watch: {
    showScore (newVal) {
      if (newVal) this.$refs.question.scrollTo({ top: 0 })
    },
  },
}
</script>
<style lang="scss" scoped>
@keyframes fadeIn {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
.vordur-outer {
  position: relative;
  overflow: auto;
  &.height-100, &.question {
    height: 100%;
  }
}
.info-component {
  height: 100%;
}
.quiz-component-wrap {
  width: 712px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 16px;
  position: relative;
  &.full-height {
    height: 100%;
  }
}

.score-page {
  position: relative;
  color: #011627;
  height: 100%;
  opacity: 0;
  animation: fadeIn 1s forwards 0.2s;
  .inner {
    padding-top: 30px;
    height: 100%;
    max-width: 566px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 0 345px;
    .score-info {
      margin-bottom: 49px;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        margin-bottom: 8px;
        height: 416px;
        width: 388px;
      }
      .total {
        font-weight: 400;
        font-size: 64px;
        line-height: 52px;
        margin-bottom: 112px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .symbol {
        color: #2EC4B6;
      }
      h5 {
        font-weight: 500;
        font-size: 20px;
        line-height: 36px;
        text-align: center;
        margin: 0 0 16px;
        color: #011627;
      }
      p {
        font-weight: 500;
        font-size: 22px;
        margin: 0;
        color: #011627;
      }
    }
    .score-image {
      svg {
        width: 372px;
        height: 312px;
      }
    }

    &.invalid {
      .symbol {
        color: #FF6A6A;
      }
      .score-image {
        svg {
          width: 325px;
        }
      }
    }
  }
}

.loader-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
  &, img {
    bottom: -10%;
    opacity: 0;
    animation: slideUp 1s forwards;
  }

  img {
    width: 100%;
    object-fit: contain;
    max-height: 400px;
  }
}

@media screen and (min-width: 768px) {
  .score-page {
    .inner {
      padding-top: 70px;
    }
  }
  .quizboard-page {
    /deep/.status-image {
      margin-top: 0 !important;
    }
  }
}

@media screen and (max-width: 767px) {
  .vordur-outer, .vordur-outer.question {
    height: 100%;
  }
  .quiz-component-wrap {
    width: 100%;
  }
  .score-page {
    padding: 0 10px;
    .inner {
      .score-info {
        img {
          height: 216px;
          width: 188px;
        }
      }
      .score-image {
        width: 100%;
      }
    }
  }
}
</style>
